<template>
    <div class="row page-titles">
      <div class="col-md-12 align-self-center">
        <div class="text-center">
            <img class="img-err" src="../../assets/images/404-error.png" alt="404 not found">
        </div>
        <div class="text-center mt-2 mb-5">
            <router-link
              :to="{ name: 'index' }"
              class="waves-effect waves-dark"
              aria-expanded="false"
            >
              <span class="hide-menu">Let's go home, buddy!</span>
            </router-link>
        </div>
      </div>
    </div>
</template>

<script>

export default {
  name: "Page404",
};
</script>
<style scoped>
    .img-err {
        width: 100%;
        max-width: 800px;
    }
</style>
